import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAllPages(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('cms/admin/libraryitems',{ params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchAllCategories(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('cms/admin/librarycategories',{ params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    
    deleteItem(ctx, queryParams) {
      var id=queryParams.id;
      queryParams.deleted=true;

//console.log("DEleting Item");
//console.log(queryParams);

      return new Promise((resolve, reject) => {
        axios
          .put(`cms/admin/updatelibraryitem`,  queryParams  )
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchPost(ctx, queryParams) {
      var id=queryParams.id;

      return new Promise((resolve, reject) => {
        axios
          .get(`cms/admin/blogpost/${id}`,{ params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    


  },
}
